module.exports = __webpack_public_path__ + "static/media/IconTemplates_-17.2e9f89ad.svg";